import { Component, OnInit, HostBinding } from '@angular/core';

@Component({
  selector: 'pg-calendar-title, grit-calendar-title',
  exportAs: 'gritCalendarTitle',
  templateUrl: './pg-calendar-title.component.html',
  styleUrls: ['./pg-calendar-title.component.scss'],
})
export class PgCalendarTitleComponent implements OnInit {
  @HostBinding('class.calendar-padding')
  _paddingClass = true;
  constructor() {}

  ngOnInit() {}
}
